import { HiOutlineLightningBolt, HiOutlineShieldCheck, HiOutlineChartBar, HiOutlineAdjustments, HiOutlineGlobeAlt, HiOutlineSparkles } from "react-icons/hi";
import Reveal from "../Reveal";
import { TbCloudDataConnection,TbAutomation  } from "react-icons/tb";
import { VscNewCollection } from "react-icons/vsc";
import { FaHandshake } from "react-icons/fa";
import { FcDecision } from "react-icons/fc";

// ------------------------------------------------------------------
// EDIT ME: swap icons (any react-icons import), title, and text.
// ------------------------------------------------------------------
const features = [
  { icon: TbCloudDataConnection , title: "Connect", desc: "Menghubungkan manusia, data, mesin, sistem, dan perangkat." },
  { icon: VscNewCollection , title: "Collect", desc: "Mengumpulkan data dari berbagai sumber." },
  { icon: FaHandshake , title: "Understand", desc: "Menggunakan software dan AI untuk memahami data." },
  { icon: FcDecision , title: "Decide", desc: "Memberikan informasi dan rekomendasi kepada manusia." },
  { icon: TbAutomation, title: "Automate", desc: "Mengotomatisasi tindakan yang dapat dilakukan sistem." }
];

const examples = [
  {
    category: "BISNIS · DEALER MOBIL",
    points: [
      "Customer bertanya lewat WhatsApp",
      "Admin menjawab satu per satu",
      "Customer tidak jadi membeli, tanpa follow-up",
    ],
    result: (
      <>
        <strong className="text-white">
          AI menjawab & memahami kebutuhan customer,
        </strong>{" "}
        memberi rekomendasi, mengumpulkan data, dan melakukan follow-up —
        sales menerima lead yang sudah qualified.
      </>
    ),
  },
  {
    category: "INDUSTRI · PABRIK",
    points: [
      "Meter listrik hanya menunjukkan angka",
      "Mesin berjalan tanpa monitoring terintegrasi",
      "Manajemen menunggu laporan, data maintenance tersebar",
    ],
    result: (
      <>
        <strong className="text-white">
          Sensor & smart meter → dashboard real-time → AI menemukan pola
          abnormal → rekomendasi penghematan → automation bertindak.
        </strong>
      </>
    ),
  },
];

export default function Features() {
  return (
    <>
      <section id="features" className="section">
        <div className="bg-blob w-80 h-80 bg-blue/20 top-0 right-1/4" />

        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <span className="section-eyebrow">
              <span className="font-mono text-md tracking-[0.25em] text-cyan-300">
                04
              </span>

              <span className="h-px w-8 bg-orange-400/70" />

              <span className="font-mono text-md tracking-[0.25em] text-slate-400">
                CARA KERJA
              </span>
            </span>
            <h2 className="section-title">
              Lima Tahap, <span className="text-gradient">satu alur</span>
            </h2>
            <p className="section-desc mx-auto">
              Bagaimana data mentah berubah menjadi tindakan nyata.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <Reveal key={f.title} direction="up" delay={(i % 3) * 0.1}>
              <div className="card h-full">
                <div className="w-12 h-12 rounded-xl bg-brand-gradient flex items-center justify-center mb-5">
                  <f.icon size={22} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{f.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mx-auto max-w-[1120px] px-6 py-20 lg:px-0 lg:py-[70px]">

          {/* Label */}
          <span className="section-eyebrow">
            <span className="font-mono text-md tracking-[0.25em] text-cyan-300">
              05
            </span>

            <span className="h-px w-8 bg-orange-400/70" />

            <span className="font-mono text-md tracking-[0.25em] text-slate-400">
              CONTOH NYATA
            </span>
          </span>
          {/* Heading */}
          <h2 className="section-title">
            Dari bisnis kecil, hingga <span className="text-gradient">pabrik besar</span>
          </h2>
          {/* Cards */}
          <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2">
            {examples.map((item, index) => (
              <div
                key={index}
                className="border border-[#29343e] bg-[#10171e] px-8 py-9  transition-all hover:scale-105"
              >
                {/* Category */}
                <div className="font-mono text-[10px] tracking-[0.15em] text-gradient">
                  {item.category}
                </div>

                {/* Card title */}
                <h3 className="mt-5 text-[20px] font-semibold text-[#18d7c7]">
                  Sebelum vs Dengan WINREVO
                </h3>

                {/* Points */}
                <ul className="mt-8 space-y-6">
                  {item.points.map((point, pointIndex) => (
                    <li
                      key={pointIndex}
                      className="flex items-start gap-4 text-[13px] leading-5 text-[#edf2f6]"
                    >
                      <span className="mt-[7px] h-[6px] w-[6px] shrink-0 rounded-full bg-[#39434d]" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                {/* Divider */}
                <div className="my-8 h-px bg-[#29333d]" />

                {/* Result */}
                <p className="text-[13px] leading-6 text-[#8da9c4]">
                  Dengan WINREVO:{" "}
                  {item.result}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
